module.exports = __webpack_public_path__ + "static/HowTheExtensionWorks@3x-81eea0a6ab99dc5938ed29931ba4fedb.png";